/* Matty Miller Studio: keep the desktop hover menu on laptops with touchscreens.
   Horizon switches to the side drawer whenever a device reports touch support.
   On devices with a mouse or trackpad (fine pointer, hover), use the top dropdown menu. */
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  function fix() {
    var header = document.querySelector('#header-component');
    if (!header || !fine.matches || window.innerWidth < 750) return;
    var list = header.querySelector('overflow-list');
    if (list && list.hasAttribute('minimum-reached')) return;
    if (header.dataset.menuStyle !== 'menu') header.dataset.menuStyle = 'menu';
  }

  /* Bold group headings in the dropdown (for example "Prints" or "Silk Scarves") are labels only,
     so shoppers always land on a curated category link underneath them. */
  var css = document.createElement('style');
  css.textContent = '.mega-menu__link--parent{pointer-events:none;cursor:default;text-decoration:none!important}' +
    '.mm-label-only{cursor:default!important}';
  document.head.appendChild(css);
  function headings(root) {
    (root || document).querySelectorAll('a.mega-menu__link--parent[href]').forEach(function (a) {
      a.removeAttribute('href');
      a.setAttribute('role', 'presentation');
      a.setAttribute('tabindex', '-1');
    });
  }

  /* Top-level menu items that only open a dropdown ("Shop"): hovering opens the menu,
     clicking does nothing, so shoppers choose a category instead. */
  var LABEL_ONLY = []; /* Shop now opens the editorial Shop page, so it is clickable again */
  function isLabelOnly(a) {
    if (!a || !a.closest('#header-component')) return false;
    if (a.closest('.mega-menu, .menu-list__submenu, [class*="submenu"]')) return false;
    return LABEL_ONLY.indexOf((a.textContent || '').trim().toLowerCase()) !== -1;
  }
  function markTop(root) {
    (root || document).querySelectorAll('#header-component a[href]').forEach(function (a) {
      if (isLabelOnly(a)) a.classList.add('mm-label-only');
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (a && isLabelOnly(a)) e.preventDefault();
  }, true);


  /* Categories with nothing for sale (listed by the "hide empty categories" header section) are hidden
     from the dropdown, the phone menu and the photo category rows. They return when stock is added. */
  function hideEmpty() {
    var list = window.mmEmptyLinks || [];
    if (!list.length) return;
    document.querySelectorAll('#header-group a[href], #header-component a[href], .mm-cats a[href]').forEach(function (a) {
      var path;
      try { path = new URL(a.getAttribute('href'), location.origin).pathname; } catch (e) { return; }
      if (list.indexOf(path) === -1) return;
      var box = a.classList.contains('mega-menu__link--parent') ? a.parentElement : (a.closest('li') || a);
      box.style.display = 'none';
      box.setAttribute('data-mm-empty', '');
    });
  }

  function start() {
    fix();
    hideEmpty();
    headings();
    markTop();
    var header = document.querySelector('#header-component');
    if (header) {
      new MutationObserver(fix).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
      new MutationObserver(function () { hideEmpty(); headings(header); markTop(header); }).observe(header, { childList: true, subtree: true });
    }
    window.addEventListener('resize', fix);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
